import { render, staticRenderFns } from "./swnotification.vue?vue&type=template&id=7c0e9f1d&"
import script from "./swnotification.vue?vue&type=script&lang=js&"
export * from "./swnotification.vue?vue&type=script&lang=js&"
import style0 from "./swnotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports